export default __webpack_public_path__ + "static/media/img1.9fbe303b.jpeg";